export const getBrochureRepoUrl = () => {
  const env = process.env.REACT_APP_ENV;
  const url = (prefix: string) => `https://aflac${prefix}.poweredbyalexia.com/brochure-management`;
  if (env === "prd") return url("");
  if (env === "local") return url("-dev");
  return url(`-${env}`);
};
